import { render, staticRenderFns } from "./IndustriesEditor.vue?vue&type=template&id=994ad4ae"
import script from "./IndustriesEditor.vue?vue&type=script&lang=ts&setup=true"
export * from "./IndustriesEditor.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports